import React, { ChangeEvent, useState, FC } from 'react'
import { Button } from 'transfix-ui/components/Button'
import Checkbox from 'transfix-ui/components/Checkbox/Checkbox'
import TextField from 'transfix-ui/components/TextField/TextField'

interface IInvalidTokenMessageProps {
  requestLoginUrl: string
}

export const InvalidTokenMessage: FC<IInvalidTokenMessageProps> = ({ requestLoginUrl }) => (
  <>
    Sorry, we didn’t recognize that email or password. If you need help, please{' '}
    <a href={requestLoginUrl}>request a login link.</a>
  </>
)

export interface LoginFormSchema {
  email?: string
  password?: string
}

interface IUsernamePasswordFormProps {
  onSubmit: ({ email, password }: LoginFormSchema) => void
  isLoading?: boolean
}

export const UsernamePasswordForm: FC<IUsernamePasswordFormProps> = ({ isLoading, onSubmit }) => {
  const [email, setEmail] = useState<string>()
  const [password, setPassword] = useState<string>()
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const emailChangeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
    setEmail(value)

  const passwordChangeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
    setPassword(value)

  const showPasswordChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) =>
    setShowPassword(checked)

  const submitFormHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit({ email, password })
  }

  return (
    <form method='post' onSubmit={submitFormHandler}>
      <div className='flex-grow-1 mb4'>
        <TextField
          autoComplete='username'
          dataTest='email-input'
          label='Email'
          large
          onChange={emailChangeHandler}
          className='fs-mask'
        />
      </div>
      <div className='flex-grow-1 mb4'>
        <TextField
          autoComplete='current-password'
          dataTest='password-input'
          label='Password'
          type={showPassword ? 'text' : 'password'}
          large
          onChange={passwordChangeHandler}
          className='fs-exclude'
        />
      </div>
      <div className='flex-grow-1 mb5'>
        <Checkbox
          checked={showPassword}
          label='Show password'
          onChange={showPasswordChangeHandler}
        />
      </div>
      <div className='flex-grow-1 mb5'>
        <Button
          disabled={isLoading}
          fullWidth
          color='primary'
          size='large'
          type='submit'
          data-test='login-submit'>
          Log In
        </Button>
      </div>
    </form>
  )
}
